import React from 'react';
import type { ComponentProps } from 'react';

import { SubtitleST3 } from 'common/components/Typography';
import type { Color } from 'common/theme/colors/types';
import type { BannerProps } from '../../../types';

type SubtitleProps = { subtitle?: BannerProps['subtitle']; textColor?: Color };

const innerSubtitleStyles: ComponentProps<typeof SubtitleST3> = {
  m: 'sp_0',
  color: 'sys.neutral.text.strong',
};

const Subtitle = ({ subtitle, textColor }: SubtitleProps) => {
  if (!subtitle) return null;

  return (
    <SubtitleST3 {...innerSubtitleStyles} color={textColor}>
      {subtitle}
    </SubtitleST3>
  );
};

export default Subtitle;
